import React from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingSpinner({ size = 'default', className = '' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    default: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <Loader2 className={`animate-spin text-primary ${sizeClasses[size]} ${className}`} />
  );
}

export function LoadingPage() {
  return (
    <div className="af-page-skeleton space-y-6" role="status" aria-label="Loading page" aria-busy="true">
      <span className="sr-only">Loading page</span>
      <div className="h-9 w-44 rounded-xl bg-muted/60" />
      <div className="h-11 rounded-xl bg-muted/40" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{[0,1,2].map(i => <div key={i} className="h-36 rounded-2xl border border-border/60 bg-muted/30" />)}</div>
    </div>
  );
}

export function LoadingOverlay() {
  return (
    <div className="absolute inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
      <LoadingSpinner size="lg" />
    </div>
  );
}
